import React, { useState } from "react";
import "../auth.scss";
import { logodarkimg, logoimg } from "../../../assets/images";
import { callicon, messageicon } from "../../../assets/icons";
import Email from "./Email";
import Number from "./Number";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Login = () => {
  const [propertyTab, setPropertyTab] = useState("email");

  return (
    <>
      <Helmet defer={false}>
        <title>
         Login to Holypills | Access Your Health Dashboard
        </title>
        <meta
          name="description"
          content="Securely log in to your Holypills account to track health, manage consultations, and access personalized wellness insights"
        />
         <meta property="og:image" content="/src/assets/images/ogImage.jpg" />
        <meta name="twitter:image" content="/src/assets/images/ogImage.jpg" />
        <link rel="canonical" href="https://holypills.in/login" />

        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Login to Holypills | Access Your Health Dashboard"
        />
        <meta
          property="og:description"
          content="Securely log in to your Holypills account to track health, manage consultations, and access personalized wellness insights"
        />

        <meta property="og:url" content="https://holypills.in/login" />
        <meta property="og:site_name" content="Holypills"></meta>

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Login to Holypills | Access Your Health Dashboard"
        />
        <meta
          name="twitter:description"
          content="Securely log in to your Holypills account to track health, manage consultations, and access personalized wellness insights"
        />

        <meta name="twitter:url" content="https://holypills.in/login"></meta>
      </Helmet>
      <div className="wrapper_auth">
        <div className="wrap_left">
          <Link to={"/"}>
            <img src={logoimg} alt="logo" />
          </Link>
          <h1>
            Balance Your Body, <span></span> Empower Your Mind
          </h1>
        </div>
        <div className="wrap_right">
          <img className="logo" src={logodarkimg} alt="logo" />

          <h2>Welcome Back to Holypills</h2>
          <div className="wrapper_cstm_tabers">
            <ul className="cstm_tabs">
              <li
                className={propertyTab === "email" ? "active" : ""}
                onClick={() => setPropertyTab("email")}
              >
                <img src={messageicon} alt="icon" />
                Email Address
              </li>
              <li
                className={propertyTab === "number" ? "active" : ""}
                onClick={() => setPropertyTab("number")}
              >
                <img src={callicon} alt="icon" />
                Mobile Number
              </li>
            </ul>
            {propertyTab === "email" && <Email />}
            {propertyTab === "number" && <Number />}
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
